<template>
  <div>
    <public-header><!-- Generic, public facing header --></public-header>
    <router-view class="router-view"><!-- component's template --></router-view>
    <public-footer><!-- Generic, public facing footer --></public-footer>
  </div>
</template>
<script>
  import PublicHeader from './PublicHeader.vue'
  import PublicFooter from './PublicFooter.vue'

  export default {
    components: {
      PublicHeader,
      PublicFooter
    }
  }
</script>
<style>
  .underline {
    text-decoration: underline;
  }
  .input, .textarea, .button {
	  border-radius: 0;
  }

  body, button, input, select, textarea, * {
	  font-family: "Open Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  }

  .free + .card-image > .image, .lite + .card-image > .image, .pro + .card-image > .image, .enterprise + .card-image > .image {
	  padding: 30px;
	  border-radius: 50%;
	  width: 150px;
	  z-index: 1;
	  margin-left: auto;
	  margin-right: auto;
	  margin-top: 30px;
  }

  .free + .card-image > .image {
	  background-color: #e8f1f5;
  }

  .lite + .card-image > .image {
	  background-color: #e9f8f6;
  }

  .pro + .card-image > .image {
	  background-color: #fff1ee;
  }

  .enterprise + .card-image > .image {
	  background-color: #f3f2fb;
  }

  .free + .card-image > .image > .circle-border, .lite + .card-image > .image > .circle-border,
  .pro + .card-image > .image > .circle-border, .enterprise + .card-image > .image > .circle-border {
	  width: 100px;
	  height: 100px;
	  border-radius: 50%;
	  position: absolute;
	  top: 25px;
	  left: 25px;
	  z-index: -1;
  }

  .free + .card-image > .image > .circle-border {
	  background-color: #cfe2ea;
  }

  .lite + .card-image > .image > .circle-border {
	  background-color: #d2f0ec;
  }

  .pro + .card-image > .image > .circle-border {
	  background-color: #ffe3dc;
  }

  .image > img {
	  width: 90px;
	  height: 90px;
	  z-index: 3;
  }

  .enterprise + .card-image > .image > .circle-border {
	  background-color: #e7e4f7;
  }

  .header-copy {
	  margin-top: 3rem;
	  margin-bottom: 3rem;
	  line-height: 2.9rem;
  }

  .card {
	  box-shadow: none;
	  border: 1px solid #e1dfdf;
  }

  .free, .pro, .lite, .enterprise {
	  color: #ffffff;
  }

  .free {
	  background-color: #1c7299;
  }

  .lite {
	  background-color: #2dbaa4;
  }

  .pro {
	  background-color: #ff7a59;
  }

  .enterprise {
	  background-color: #8d7dda;
  }

  .card-header {
	  font-weight: normal;
  }

  .card-header-title.is-centered {
	  color: #ffffff;
	  font-weight: lighter;
  }

  .card-header-title.is-centered {
	  text-align: center;
  }

  .card > .card-header {
	  padding: 1rem;
  }

  .card > .card-header > .media-content > p:first-child {
	  font-size: 1.4rem;
	  font-weight: lighter;
  }

  .card > .card-header > .media-content > p:not(:first-child) {
	  font-size: 1.0rem;
	  font-weight: bolder;
  }

  @media screen and (max-width: 767px) {
	  .header-copy {
		  margin-top: 2rem;
		  margin-bottom: 2rem;
	  }

	  .card, .columns > .column {
		  margin-top: 20px;
		  margin-left: 30px;
		  margin-right: 30px;
	  }
  }

  @media screen and (max-width: 1024px) {
    .router-view {
      margin-top: 62px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/layouts/Public.vue